import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { loadQuoteCart } from './mini-quote-cart.actions';

@Injectable({ providedIn: 'root' })
export class QuoteCartFacade {
  constructor(private store: Store<any>) {}

  loadCart() {
    this.store.dispatch(loadQuoteCart());
  }

  getCartData() {
    return this.store.select(state => state?.quoteCart?.cartData);
  }
}